<template>
    <div>
        <product
                v-for="(product, index) in displayedProducts"
                :product="product"
                :index="index"
                :key="product.id"
        >
        </product>
    </div>
</template>
<script>
    import { forEach, filter } from 'lodash';
    export default {
        data() {
            return {};
        },

        computed: {
            displayedProducts() {
                return this.$store.getters.displayedProducts;
            }
        }
    }
</script>